._3q9dx30 {
  box-sizing: border-box;
  font-family: Inter Variable, sans-serif;
  font-weight: 700;
  font-size: 13px;
  line-height: 1.5;
  text-align: center;
  text-decoration: none;
  color: white;
  background-color: #252525;
  border-radius: 32px;
  cursor: pointer;
}
._3q9dx30:disabled {
  background-color: #CCCCCC;
}
._3q9dx31 {
  font-size: 13px;
  padding: 8px 16px;
}
._3q9dx32 {
  font-size: 18px;
  padding: 16px 24px;
}
._3q9dx33 {
  background-color: #E46327;
}
._3q9dx34 {
  background-color: white;
  color: #252525;
  border: 1.5px solid #252525;
}
._3q9dx34._3q9dx31 {
  padding: 6.5px 14.5px;
}
._3q9dx34._3q9dx32 {
  padding: 14.5px 22.5px;
}
._3q9dx35 {
  background-color: #ED0006;
}
._3q9dx36 {
  width: 100%;
}